import VerticalTimerTabs from "segments/desktop/core-components/vertical-timer-tabs/vertical-timer-tabs";
import ProductDescription from "segments/desktop/core-components/products-tabs/product-description/product-description";
import ProductTitle from "segments/desktop/core-components/products-tabs/product-title/product-title";
import { CRM_PRODUCT_ID, DEV_PRODUCT_ID, WORK_MANAGEMENT_PRODUCT_ID } from "constants/products";
import colors from "styles/colors";
import {
  BRAND_BLACK_BACKGROUND_COLOR,
  BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME,
  CRM_DARKER_TINT_02_COLOR_NAME,
  DEV_DARKER_TINT_02_COLOR_NAME,
  WHITE_COLOR_NAME,
  WORK_OS_IRIS_COLOR_NAME,
  BRAND_BLACK_TEXT_COLOR,
  CRM_PRIMARY_COLOR,
  BRAND_PRIMARY_GREEN
} from "styles/color-consts";
import { useCallback } from "react";
import { componentStyles } from "./products-tabs.scss";
import DefaultProps from "./default-props";
import classNames from "classnames";

const ProductsTabs = ({ tabTitleConfig, translate, isV2, ...restOfProps }) => {
  const PRODUCT_TO_COLORS = {
    [WORK_MANAGEMENT_PRODUCT_ID]: {
      text: isV2 ? colors[WHITE_COLOR_NAME] : colors[BRAND_WORK_MANAGEMENT_CONTRAST_COLOR_NAME],
      cta: WORK_OS_IRIS_COLOR_NAME,
      backgroundColor: colors[WORK_OS_IRIS_COLOR_NAME]
    },
    [CRM_PRODUCT_ID]: {
      text: isV2 ? colors[BRAND_BLACK_TEXT_COLOR] : colors[CRM_DARKER_TINT_02_COLOR_NAME],
      cta: CRM_DARKER_TINT_02_COLOR_NAME,
      backgroundColor: colors[CRM_PRIMARY_COLOR]
    },
    [DEV_PRODUCT_ID]: {
      text: isV2 ? colors[BRAND_BLACK_TEXT_COLOR] : colors[BRAND_BLACK_BACKGROUND_COLOR],
      cta: DEV_DARKER_TINT_02_COLOR_NAME,
      backgroundColor: colors[BRAND_PRIMARY_GREEN]
    }
  };

  const getProductColor = useCallback(
    (productType) => PRODUCT_TO_COLORS[productType || WORK_MANAGEMENT_PRODUCT_ID],
    []
  );

  const contentRenderer = (contentObject, tabData) => {
    const productColor = getProductColor(tabData?.productType);

    return (
      <ProductDescription
        productType={tabData?.productType}
        featureColor={productColor?.text}
        ctaColor={productColor?.cta}
        translate={translate}
        isV2={isV2}
        {...contentObject}
      />
    );
  };

  const getTabIdentifier = (tabData) => tabData?.content?.productType;

  const tabTitleRenderer = (tabTitle, tabData) => {
    if (!tabTitle) return null;

    const { title, body, productImage, useCases } = tabTitle;
    const productColor = getProductColor(tabData?.productType);

    return (
      <ProductTitle
        color={productColor?.text}
        backgroundColor={productColor?.backgroundColor}
        isV2={isV2}
        titleConfig={tabTitleConfig}
        productImage={productImage}
        title={title}
        body={body}
        useCases={useCases}
      />
    );
  };

  return (
    <div
      className={classNames("products-tabs", {
        "invert-colors": isV2
      })}
    >
      <VerticalTimerTabs
        {...restOfProps}
        getTabIdentifier={getTabIdentifier}
        title={{ lineHeight: "fit-content" }}
        tabTitleRenderer={tabTitleRenderer}
        isFullScreen={false}
        rightSideRenderer={() => <></>}
        tabContentRenderer={contentRenderer}
        isCollapsable
      />

      <style jsx>{componentStyles}</style>
    </div>
  );
};

export default ProductsTabs;

ProductsTabs.defaultProps = DefaultProps;
